import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

export default (history) => combineReducers({
  router: connectRouter(history)
});


// WEBPACK FOOTER //
// src/reducer.js